var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.$t('Too Many Login Attempts')))]},proxy:true},{key:"text",fn:function(){return [_vm._v(_vm._s(_vm.$t('Please try again later.')))]},proxy:true},{key:"button",fn:function(){return [_vm._v(" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }